import { Form, Formik } from 'formik'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import { useReactToPrint } from 'react-to-print'
import styled from 'styled-components'
import * as Yup from 'yup'
import Button from './Button'
import FlexLayout from './FlexLayout'
import FormField from './Form/FormField'
import Text from './Text'
import lodash from 'lodash'

const PageBreak = styled.div`
  @media all {
    display: none;
  }
  @media print {
    html,
    body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }
  @media print {
    margin-top: 1rem;
    display: block;
    page-break-before: always;
  }
  @page {
    size: auto;
    margin: 30mm;
  }
`

function TagPrinterManager({
  showTagModal,
  setShowTagModal,
  labelsToPrint = [],
  setLabelsToPrint,
  donePrint
}) {
  const handleCloseModal = () => setShowTagModal(false)
  const [current, setCurrent] = useState(0)
  const [amount, setAmount] = useState(1)
  const [printing, setPrinting] = useState(false)
  const componentRef = useRef()
  const print = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
    onAfterPrint: () => { setPrinting(false) }
  })
  const handlePrint = () => {
    setPrinting(true)
    print()
  }

  const handleFinishPrint = () => {
    donePrint()
    setCurrent(0)
    setAmount(0)
  }

  useEffect(() => {
    if (labelsToPrint.length > 0) {
      let ordenedPrintedLabels = labelsToPrint.sort(
        (a, b) => b.props.obj.printed - a.props.obj.printed
      )
      setLabelsToPrint(ordenedPrintedLabels)
    }
  }, [labelsToPrint, setLabelsToPrint])
  const addIndexToLabel = (index) => {
    let labelToPrintClone = lodash.cloneDeep(labelsToPrint[current])
    if(!labelToPrintClone) return labelsToPrint[current]
    labelToPrintClone.props.obj.currentToPrint = `${index}/${amount ? amount : '-'}`

    return labelToPrintClone
  }

  return (
    <>
      <Modal
        show={showTagModal}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        size="md"
        style={{ height: '100vh', margin: '0 auto' }}
        centered
      >
        <Modal.Header style={{ padding: '0 1rem' }}>
          <Modal.Title>Impressão de Etiquetas</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '0' }}>
          <FlexLayout justify="center">
            <Formik
              initialValues={{
                labelAmount: 1
              }}
              validationSchema={Yup.object().shape({
                labelAmount: Yup.number()
                  .required('form.required')
                  .min(1, 'O valor minímo deste campo é: 1')
              })}
              onSubmit={() => {
                labelsToPrint[current].props.obj.printed = true
                setLabelsToPrint([...labelsToPrint])

                handlePrint()
              }}
              validateOnBlur
            >
              {({ values, handleSubmit }) => {
                const labelToPrint = addIndexToLabel(1)
                
                return (
                  <Form>
                    <FormField
                      name="labelAmount"
                      label="receivement.labelPrinting.labelAmount"
                      onBlur={setAmount(values.labelAmount)}
                      fieldType="number"
                      style={{ width: '200px', marginBottom: '20px' }}
                    />
                    <Text text="receivement.labelPrinting.preview" />
                    <>{labelToPrint}</>
                    <FlexLayout
                      justify="around"
                      style={{ margin: '40px auto 28px' }}
                    >
                      {current > 0 ? (
                        <Button
                          text="receivement.labelPrinting.previousButton"
                          style={{ marginRight: '10px' }}
                          isDisabled={!labelsToPrint[current].props.obj.printed}
                          onClick={() =>
                            labelsToPrint[current].props.obj.printed
                              ? setCurrent((prev) => prev - 1)
                              : null
                          }
                        />
                      ) : (
                        ''
                      )}
                      <Button
                        text="receivement.labelPrinting.printButton"
                        testId='print-button'
                        style={{ marginRight: '10px' }}
                        onClick={() => {
                          handleSubmit()
                        }}
                      />
                      {current < labelsToPrint.length - 1 ? (
                        <Button
                          text="receivement.labelPrinting.nextButton"
                          style={{ marginRight: '10px' }}
                          isDisabled={!labelsToPrint[current].props.obj.printed}
                          onClick={() =>
                            labelsToPrint[current].props.obj.printed
                              ? setCurrent((prev) => prev + 1)
                              : null
                          }
                        />
                      ) : (
                        ''
                      )}
                      <Button
                        text="receivement.labelPrinting.doneButton"
                        style={{ marginRight: '10px' }}
                        isDisabled={
                          current === labelsToPrint.length - 1
                            ? !labelsToPrint[current].props.obj.printed
                            : true
                        }
                        onClick={() =>
                          labelsToPrint[current].props.obj.printed
                            ? handleFinishPrint()
                            : null
                        }
                        testId='button-done-print'
                      />
                    </FlexLayout>
                    <FlexLayout justify="around">
                      <Text
                        plainText={`${current + 1}/${labelsToPrint.length}`}
                      />
                    </FlexLayout>
                  </Form>
                )
              }}
            </Formik>
          </FlexLayout>
        </Modal.Body>
      </Modal>

      {labelsToPrint.length > 0 && (
        <div style={{ display: 'none' }}>
          <div ref={componentRef} style={{ margin: '40px' }}>
            {printing && Array.from({ length: amount }, (_, index) => {
              const labelToPrint = addIndexToLabel((index+1))

              return (
                <Fragment key={index}>
                  <PageBreak />
                  {labelToPrint}
                </Fragment>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}

export default TagPrinterManager
